import { useCallback, useEffect, useRef, useState } from 'react';
import { createPopper } from '@popperjs/core';
import { Placements } from './TooltipPlacementType';
var usePopper = function (placement) {
    var _a = useState(false), toggledState = _a[0], setToggledState = _a[1];
    var _b = useState(null), popperInstance = _b[0], setPopperInstance = _b[1];
    var triggerRef = useRef();
    var popupRef = useRef();
    var showHandler = useCallback(function () {
        setToggledState(true);
    }, [toggledState]);
    var hideHandler = useCallback(function () {
        setToggledState(false);
    }, [toggledState]);
    useEffect(function () {
        var popper;
        if ((triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) && popupRef.current) {
            popper = createPopper(triggerRef.current, popupRef.current, {
                placement: placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: function (_a) {
                                var placement = _a.placement, popper = _a.popper;
                                var skidding = null;
                                var distance = null;
                                switch (placement) {
                                    case Placements.Top:
                                    case Placements.Bottom:
                                        skidding = 0;
                                        distance = 0;
                                        break;
                                    case Placements.TopStart:
                                    case Placements.BottomStart:
                                        skidding = -(popper.width / 2);
                                        distance = 0;
                                        break;
                                    case Placements.TopEnd:
                                    case Placements.BottomEnd:
                                        skidding = popper.width / 2;
                                        distance = 0;
                                        break;
                                    case Placements.Right:
                                    case Placements.Left:
                                        skidding = 0;
                                        distance = 0;
                                        break;
                                    case Placements.RightStart:
                                    case Placements.LeftStart:
                                        skidding = -(popper.height / 6);
                                        distance = 0;
                                        break;
                                    case Placements.RightEnd:
                                    case Placements.LeftEnd:
                                        skidding = popper.height / 6;
                                        distance = 0;
                                        break;
                                    default:
                                        break;
                                }
                                return [skidding, distance];
                            }
                        }
                    }
                ]
            });
            setPopperInstance(popper);
        }
        return function () { return popper === null || popper === void 0 ? void 0 : popper.destroy(); };
    }, [placement]);
    useEffect(function () {
        toggledState === true && popperInstance.forceUpdate();
    }, [toggledState, popperInstance]);
    return [
        triggerRef,
        popupRef,
        toggledState,
        popperInstance && popperInstance.state.placement,
        showHandler,
        hideHandler
    ];
};
export default usePopper;
